module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/voice-logo-naracamicie-6d82186f432b7e9d6401935b57f93316.png";